export default { "none":"Aucun", "send":"ENVOYER", "sendMessage":"ENVOYER LE MESSAGE", "sending":"ENVOI..." } as const;
